import { defineComponent, reactive, toRefs, computed, withModifiers, getCurrentInstance, } from 'vue';
import useConfigInject from '../_util/hooks/useConfigInject';
import classNames from '../_util/classNames';
import { OperationType, TreeNodeType } from './utils/types';
import Icon from '../icon';
import Dropdown from '../dropdown';
import Menu, { MenuItem } from '../menu';
export const nodeProps = () => ({
    nodeDelete: Function,
    nodeShrink: Function,
    nodeAppend: Function,
    nodeInsert: Function,
    nodeClick: Function,
    menuClick: Function,
    nodeMousedown: Function,
    nodeMouseup: Function,
    getMenuPopupContainer: { type: Function },
});
const StgyGraphNode = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyGraphNode',
    props: nodeProps(),
    emits: [],
    slots: ['header', 'content', 'tools'],
    setup(props, { slots }) {
        const { prefixCls } = useConfigInject('stgy-graph-node', props);
        const { appContext: { config: { globalProperties: { $props }, }, }, } = getCurrentInstance();
        const { node, readonly, selectedNodeId, miniStartNode } = toRefs($props);
        const state = reactive({
            nodeRef: null,
        });
        const { nodeRef } = toRefs(state);
        const dragging = computed(() => node.value.meta?.extParam?.isDragging);
        // 是否为高亮节点
        const isHighLight = computed(() => node.value.meta?.extParam?.isHighLight);
        // 是否为拖拽节点
        const isDragElement = computed(() => node.value.meta?.extParam?.isDragElement);
        const isToolsNode = computed(() => {
            return node.value?.meta?.type === TreeNodeType.TOOLS;
        });
        const nodeClassNames = computed(() => {
            const classNameObj = {
                [`${prefixCls.value}`]: true,
                'selected-node': selectedNodeId.value.includes(node.value.id),
                'lighten-node': isHighLight.value,
                'dragging-node': dragging.value,
                'start-node': node.value?.meta?.configKey === 'start_node',
                'start-node-mini': node.value?.meta?.configKey === 'start_node' && miniStartNode.value,
            };
            return classNameObj;
        });
        const style = computed(() => {
            const { width, height } = node.value;
            return {
                width: width + 'px',
                height: height + 'px',
            };
        });
        const deleteNodeStyle = computed(() => {
            const { width } = node.value;
            return {
                position: 'absolute',
                top: `${isToolsNode.value ? 7 : 8}px`,
                left: width - 18 - 12 + 'px',
            };
        });
        const nodeDelete = () => {
            props?.nodeDelete(node.value);
        };
        const nodeMousedown = (evt) => {
            props.nodeMousedown(evt, node.value);
        };
        const nodeMouseup = () => {
            props.nodeMouseup(node.value);
        };
        const nodeDeleteDown = () => {
            // 占位
        };
        return () => {
            // 删除按钮
            let deleteNode = null;
            if (node.value?.meta?.type !== TreeNodeType.TOOLS &&
                node.value.meta?.configKey !== 'start_node' &&
                !readonly.value) {
                deleteNode = (<>
            <div onMousedown={withModifiers(nodeDeleteDown, ['left', 'prevent', 'stop'])} onMouseup={withModifiers(nodeDelete, ['left', 'prevent', 'stop'])} style={deleteNodeStyle.value} class="node-delete">
              <Icon class={`icon-delete ${isToolsNode.value ? 'icon-tools-delete' : ''}`} icon-class="wd-icon-tips_close_circle"></Icon>
            </div>
          </>);
            }
            // 内容渲染
            let renderNode = null;
            if (node.value?.meta?.type === TreeNodeType.TOOLS) {
                const renderToolsNode = slots?.tools;
                if (renderToolsNode) {
                    renderNode = (<>
              <div onMousedown={withModifiers(nodeMousedown, ['left'])} onMouseup={withModifiers(nodeMouseup, ['left'])}>
                {renderToolsNode()}
              </div>
            </>);
                }
            }
            else {
                renderNode = (<>
            {node.value?.width > 0 && (<div class={classNames({
                            [`${prefixCls.value}-wrap`]: true,
                            [`${prefixCls.value}-wrap-buy`]: node.value?.meta?.configKey === 'buy',
                            [`${prefixCls.value}-wrap-sell`]: node.value?.meta?.configKey === 'sell',
                            [`${prefixCls.value}-wrap-error`]: node.value?.meta?.extParam?.errorStatus,
                        })} onMousedown={withModifiers(nodeMousedown, ['left'])} onMouseup={withModifiers(nodeMouseup, ['left'])}>
                <div class={`${prefixCls.value}-wrap-header`}>{slots?.header?.()}</div>
                {slots?.content && (<div class={`${prefixCls.value}-wrap-bottom`}>{slots?.content?.()}</div>)}
                {deleteNode}
              </div>)}
          </>);
            }
            if (isDragElement.value) {
                const dragStyle = {
                    width: node.value.width + 'px',
                    height: node.value.height + 'px',
                };
                return (<>
            <div data-id={node.value.id} style={dragStyle} class={`${prefixCls.value}-dragging`}></div>
          </>);
            }
            else {
                return (<div ref={nodeRef} tabindex="-1" class={nodeClassNames.value} style={style.value} data-id={node.value.id}>
            {renderNode}
          </div>);
            }
        };
    },
});
export default StgyGraphNode;
// 【添】
export const StgyGraphAppend = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyGraphAppend',
    props: nodeProps(),
    setup(props) {
        const { prefixCls } = useConfigInject('stgy-graph-node', props);
        const { appContext: { config: { globalProperties: { $props }, }, }, } = getCurrentInstance();
        const { node, menus } = toRefs($props);
        const handleMenuClick = (key) => {
            props?.menuClick({ operationType: OperationType.APPEND, nodeType: key, node: node.value });
        };
        const nodeAppend = () => {
            props?.nodeAppend(node.value);
        };
        return () => {
            // 添加按钮
            let appendNode = null;
            appendNode = (<>
          <Dropdown trigger={'click'} getPopupContainer={props.getMenuPopupContainer} destroyPopupOnHide v-slots={{
                    overlay: () => (<Menu onClick={({ key }) => {
                            handleMenuClick(key);
                        }}>
                  {menus.value.map(menu => {
                            return (<MenuItem disabled={menu.disabled} key={menu.value}>
                        {menu.name}
                      </MenuItem>);
                        })}
                </Menu>),
                    default: () => (<div onClick={nodeAppend} class={`${prefixCls.value}-append`}>
                  <Icon icon-class="wd-icon-special_append"></Icon>
                </div>),
                }}></Dropdown>
        </>);
            return <>{appendNode}</>;
        };
    },
});
// 【+】
export const StgyGraphInsert = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyGraphInsert',
    props: nodeProps(),
    setup(props) {
        const { prefixCls } = useConfigInject('stgy-graph-node', props);
        const { appContext: { config: { globalProperties: { $props }, }, }, } = getCurrentInstance();
        const { node, menus } = toRefs($props);
        const handleMenuClick = (key) => {
            props?.menuClick({ operationType: OperationType.INSERT, nodeType: key, node: node.value });
        };
        const nodeInsert = () => {
            props?.nodeInsert(node.value);
        };
        return () => {
            // 插入按钮
            let insertNode = null;
            insertNode = (<>
          <Dropdown trigger={'click'} getPopupContainer={props.getMenuPopupContainer} destroyPopupOnHide v-slots={{
                    overlay: () => (<Menu onClick={({ key }) => {
                            handleMenuClick(key);
                        }}>
                  {menus.value.map(menu => {
                            return (<MenuItem disabled={menu.disabled} key={menu.value}>
                        {menu.name}
                      </MenuItem>);
                        })}
                </Menu>),
                    default: () => (<div onClick={nodeInsert} class={classNames({
                            [`${prefixCls.value}-insert`]: true,
                        })}>
                  <Icon class="icon-plus" icon-class="wd-icon-tips_plus_circle"></Icon>
                </div>),
                }}></Dropdown>
        </>);
            return <>{insertNode}</>;
        };
    },
});
// 【展开收起】
export const StgyGraphShrink = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyGraphShrink',
    props: nodeProps(),
    setup(props) {
        const { prefixCls } = useConfigInject('stgy-graph-node', props);
        const { appContext: { config: { globalProperties: { $props }, }, }, } = getCurrentInstance();
        const { node } = toRefs($props);
        // 收起节点的收起数量
        const shrinkNum = computed(() => node.value.meta.extParam.shrinkNum);
        // 节点是否为展开收起
        const isOpen = computed(() => node.value.meta.extParam.isOpen);
        // 是否为合并节点
        const isMergeNode = computed(() => node.value.meta.extParam.isMergeNode);
        // 展开收起禁用
        const shrinkDisabled = computed(() => node.value.meta.extParam.shrinkDisabled);
        const nodeShrink = () => {
            if (shrinkDisabled.value) {
                return;
            }
            props?.nodeShrink(node.value);
        };
        return () => {
            // 展开收起按钮
            let shrinkNode = null;
            shrinkNode = (<>
          <div class={classNames(`${prefixCls.value}-shrink`, {
                    [`${prefixCls.value}-shrink__disabled`]: shrinkDisabled.value,
                    [`${prefixCls.value}-shrink__collaspe`]: !isOpen.value,
                    [`${prefixCls.value}-shrink__merge-collaspe`]: isMergeNode.value && isOpen.value === false,
                })} onClick={withModifiers(nodeShrink, ['left', 'prevent', 'stop'])}>
            {isOpen.value ? (<Icon icon-class="wd-icon-tips_minus_circle" class={`${prefixCls.value}-shrink__icon`}></Icon>) : (<div class={`${prefixCls.value}-shrink__expand`}>
                {shrinkNum.value > 99 ? (<Icon icon-class="wd-icon-interactive_more" class={`${prefixCls.value}-shrink__icon`}></Icon>) : (shrinkNum.value)}
              </div>)}
          </div>
        </>);
            return <>{shrinkNode}</>;
        };
    },
});
